import styled from 'styled-components'

interface IFileActionContainerStyled {}

export const FileActionContainerStyled = styled.div<IFileActionContainerStyled>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
`
